var translations = {
  'bundle.conversion.confirm': 'Convert',
  'bundle.conversion.content': 'Convert to {name}? Save {savings}!',
  'bundle.conversion.chooseBundle': 'Multiple bundles match — choose one:',
  'bundle.conversion.otherOptions': '{count} other bundle(s) also available',
  'bundle.conversion.savingsLabel': 'Save {savings}',
  'bundle.conversion.title': 'Bundle available',
  'cart.discount.dialog.title': 'Select discount',
  'cart.discount.discounts.no': 'No discount',
  'cart.discount.info.body': 'Add more discounts or edit existing discounts in',
  'cart.discount.info.linkText': 'Admin → Discounts',
  'cart.discount.info.title': 'Manage discounts:',
  'cart.discount.label': 'Discount applied',
  'cart.discount.label.openBill': 'Can not apply discount to open bill orders. Apply the discount when paying.',
  'cart.discount.noOrderLinesQualify': 'No order lines qualify for discount',
  'cart.wastage.dialog.error': 'Something went wrong while registering wastage.',
  'cart.wastage.dialog.reason.comment.placeholder': 'Comment/ other cause',
  'cart.wastage.dialog.reason.comment.title': 'Comment',
  'cart.wastage.dialog.reason.type.CUSTOMER_COMPLAINT': 'Customer complaint',
  'cart.wastage.dialog.reason.type.DRAFT_FOAM_LINE_CLEANING': 'Draft foam / line cleaning',
  'cart.wastage.dialog.reason.type.EXPIRED_PRODUCT': 'Expired product',
  'cart.wastage.dialog.reason.type.FAULTY_PRODUCT': 'Faulty product',
  'cart.wastage.dialog.reason.type.OTHER': 'Other (fill in comment)',
  'cart.wastage.dialog.reason.type.SPILLAGE': 'Spillage',
  'cart.wastage.dialog.success': 'Wastage reported',
  'cart.wastage.dialog.title': 'Select waste cause',
  'checkout.addedTo': 'Added to',
  'checkout.table': 'Table',
  'checkout.addToBillBannerButton': 'Go to bill',
  'checkout.addToOpenBill': 'Add to Open bill',
  'checkout.cartError.message':
    'Something went wrong when we tried to update the cart. Try to empty the cart, check that device is connected to internet, or restart the device.',
  'checkout.cartError.title': 'Cart update failed',
  'checkout.confirmPayment': 'When you have received the payment, confirm below.',
  'checkout.delivery.COUNTER': 'Counter',
  'checkout.delivery.HOME_DELIVERY': 'Delivery',
  'checkout.delivery.PICKUP': 'Pickup',
  'checkout.delivery.ROOM': 'Conference room',
  'checkout.delivery.ROOM_SERVICE': 'Room service',
  'checkout.delivery.SEAT': 'Seat',
  'checkout.delivery.TABLE': 'Table',
  'checkout.delivery.TAKEAWAY': 'Takeaway',
  'checkout.delivery.ONLINE': 'Online',
  'checkout.deliveryPoint.COUNTER': 'Counter',
  'checkout.deliveryPoint.HOME_DELIVERY': 'Address',
  'checkout.deliveryPoint.ROOM_SERVICE': 'Room',
  'checkout.deliveryPoint.SEAT': 'Seat number',
  'checkout.deliveryPoint.TABLE': 'Table',
  'checkout.deliveryPoint.TAKEAWAY': 'Takeaway',
  'checkout.deliveryPoint.ONLINE': 'Online',
  'checkout.deliveryPoint.deliverTo': 'Deliver to:',
  'checkout.deliveryPoint.primary.HOME_DELIVERY': 'Address',
  'checkout.deliveryPoint.primary.ROOM_SERVICE': 'Room number',
  'checkout.deliveryPoint.primary.SEAT': 'Seat number',
  'checkout.deliveryPoint.primary.TABLE': 'Table number',
  'checkout.deliveryPoint.secondary.SEAT': 'Row number',
  'checkout.deliveryPoint.tertiary.SEAT': 'Section number',
  'checkout.eatInOrTakeaway.eatIn': 'Eat in',
  'checkout.eatInOrTakeaway.takeaway': 'Takeaway',
  'checkout.emptyCart': 'Empty cart',
  'checkout.emptyCart.content': 'This will remove all the items from the cart.',
  'checkout.emptyCart.title': 'Empty cart?',
  'checkout.generalError.cart': 'Cart ID:',
  'checkout.generalError.debug': 'If the issue persists, contact our support. They might need this information:',
  'checkout.generalError.timestamp': 'Timestamp:',
  'checkout.note.description': 'Anything the kitchen needs to know?',
  'checkout.note.header': 'Add a note to the kitchen',
  'checkout.outOfStockError.message': 'Please remove them from your Cart to continue.',
  'checkout.outOfStockError.title': 'Out of stock item(s) in cart',
  'checkout.splitByItems': 'Split by items',
  'checkout.splitEqually': 'Split equally',
  'checkout.pay': 'Pay',
  'checkout.continue': 'Continue',
  'checkout.payByAmount': 'Pay by amount',
  'checkout.paySelected': 'Pay selected',
  'checkout.paymentBanner': 'Payment Confirmed',
  'checkout.paymentButton': 'Confirm Payment',
  'checkout.paymentButton.newFlow.CASH': 'Cash',
  'checkout.paymentButton.newFlow.CASH.connected': 'Pay now',
  'checkout.paymentButton.newFlow.CASH.disconnected': 'Disconnected',
  'checkout.paymentButton.newFlow.CASH.error': 'Error',
  'checkout.paymentButton.newFlow.CASH.not found': 'Drawer not found',
  'checkout.paymentButton.state.busy': 'Unavailable',
  'checkout.paymentButton.state.inUse': 'In use...',
  'checkout.paymentButton.state.maintenance': 'Updating',
  'checkout.paymentButton.state.unknown': 'Unknown',
  'checkout.paymentButton.state.unreachable': 'Offline',
  'checkout.paymentError.message':
    'Something went wrong when we tried to confirm the payment. Check that the device is connected to the Internet, or try to restart the device. ',
  'checkout.paymentError.title': 'Payment failed',
  'checkout.sectionError.message':
    'One or more items in your cart belong to a section that is closed or disabled. Please remove them from your cart to continue:',
  'checkout.sectionError.title': 'Unavailable item(s) in cart',
  'checkout.sendToDigitalBill': 'Add to bill',
  'checkout.tableNumberDialog.confirm': 'Set table',
  'checkout.tablePayment': 'Payment for Table',
  'checkout.unavailableError.message':
    'Item(s) in your cart have been disabled from admin. Please remove them from your cart to continue:',
  'checkout.unavailableError.title': 'Unavailable item(s) in cart',
  'checkout.waitingForPayment': 'Awaiting payment from guest...',
  'checkout.invoiceField.description': 'Customers from the accounting system that are allowed to use invoice.',
  'checkout.invoiceField.placeholder': 'Search to add customer',
  'digitalBill.FOR': 'Open bill for',
  'digitalBill.back': 'Back to open bills',
  'digitalBill.create.leadingZerosDisallowed':
    'Table numbers cannot start with 0. Only the digits after 0 will count as the table number.',
  'digitalBill.created': 'Bill opened',
  'digitalBill.deletedBillBanner': 'Deleted',
  'digitalBill.settledBillBanner': 'Table settled',
  'digitalBill.editBillDetails.button.icon': 'Edit details',
  'digitalBill.editBillDetails.confirm': 'Save changes',
  'digitalBill.editBillDetails.invalid': 'This table number already exists. Please select an unused table number.',
  'digitalBill.editBillDetails.label': 'Table number',
  'digitalBill.editBillDetails.title': 'Edit bill details',
  'digitalBill.editBillDetails.toast.error': 'There was an error updating details',
  'digitalBill.editBillDetails.toast.success': 'Details updated',
  'digitalBill.emptyState': 'Select a bill to see details',
  'digitalBill.invite': 'Invite guest',
  'digitalBill.invite.invitationInfo': 'The guest can see the bill',
  'digitalBill.invite.invitationInfo.addOrders': 'Add orders',
  'digitalBill.invite.invitationInfo.addOrders.buttonText': 'Invite guest to order',
  'digitalBill.invite.invitationInfo.addOrders.description':
    'Pro tip: Print the QR code, and give it to the guest when you deliver the first order.',
  'digitalBill.invite.invitationInfo.addOrders.header': 'Enable guests to order when you are busy',
  'digitalBill.invite.invitationInfo.pay': 'Pay the bill',
  'digitalBill.invite.invitationInfo.pay.buttonText': 'Invite guest to pay',
  'digitalBill.invite.invitationInfo.pay.description':
    'Pro tip: Print the QR code, and give it to the guest when you deliver the first order.',
  'digitalBill.invite.invitationInfo.pay.header': 'Enable guests to pay in 10 seconds!',
  'digitalBill.openBillButton': 'Open table',
  'digitalBill.openBillButton.tableExists': 'Select table',
  'digitalBill.paid': 'Paid last 12h',
  'digitalBill.printBill.choosePrinter': 'Choose printer',
  'digitalBill.paidLastHours': 'Paid bills last 12 hours',
  'digitalBill.printBill.buttonLabel': 'Print bill',
  'digitalBill.printBill.print.error': 'Could not print bill',
  'digitalBill.printBill.print.success': 'Printing bill',
  'digitalBill.printQR.print.error': 'Could not print QR code',
  'digitalBill.printQR.print.success': 'Printing QR code',
  'digitalBill.shortenHour': 'h',
  'digitalBill.shortenMinute': 'min',
  'digitalBill.tableExists':
    'Table {tableNumber} already exists. Add a new table number or select the existing table below.',
  'digitalBill.tableExists.confirmLabel': 'Use existing table {tableNumber}',
  'digitalBill.tableExists.protip': 'Pro tip: You can also use period in the number field. (e.g. 10.2)',
  'digitalBill.tableExists.tableStatus': 'Last updated: {updated}. Unpaid: {sum}',
  'digitalbill.discardSelected': 'Discard selected',
  'digitalbill.invite.guest.sms.button': 'Send SMS invite',
  'digitalbill.invite.guest.sms.failure':
    'Sorry, that is a phone number we don’t know how to verify. Does it have between 8-15 digits?',
  'digitalbill.invite.guest.sms.input.label': 'Phone Number',
  'digitalbill.moveSelected': 'Move selected',
  'digitalBill.checkout.editAmount.title': 'Edit amount',
  'digitalBill.checkout.editAmount.inputLabel': 'Amount for this payment',
  'digitalBill.checkout.editAmount.invalidAmount': 'This amount is higher than what is remaining of the bill.',
  'digitalBill.checkout.editAmount.remainingAmountTooLow': 'The remaining amount cannot be less than {amount}.',
  'digitalBill.checkout.editAmount.description':
    'By changing the amount, you can split the total into several payment methods.',
  'digitalBill.checkout.addToBill': 'Add to bill',
  'digitalBill.correction.button': 'Correction',
  'digitalBill.correction.dialog.title': 'Bill correction',
  'digitalBill.correction.dialog.reasonLabel': 'Reason',
  'digitalBill.correction.dialog.reason.CLOSE_TABLE': 'Close table',
  'digitalBill.correction.dialog.reason.DINE_AND_DASH': 'Dine and dash',
  'digitalBill.correction.dialog.reason.SERVICE_ISSUE': 'Service issue',
  'digitalBill.correction.dialog.reason.OTHER': 'Other',
  'digitalBill.correction.dialog.amountLabel': 'Correction amount',
  'digitalBill.correction.dialog.commentLabel': 'Comment',
  'digitalBill.correction.dialog.commentLabelRequired': 'Comment (required)',
  'digitalBill.correction.dialog.commentPlaceholder': 'Additional details',
  'digitalBill.correction.dialog.currentRemaining': 'Current remaining',
  'digitalBill.correction.dialog.newRemaining': 'New remaining',
  'digitalBill.correction.dialog.amountExceedsRemaining': 'Amount cannot exceed {max}',
  'digitalBill.correction.toast.success': 'Bill correction applied',
  'digitalBill.correction.toast.error': 'Failed to apply correction',
  'discardSelectedItems.toast.failure': 'Failed to discard selected items',
  'discardSelectedItems.toast.success': 'Items discarded',
  'generic.OpenBills': 'Open bills',
  'generic.and': 'and',
  'generic.back': 'Back',
  'generic.bill': 'Bill',
  'generic.cancel': 'Cancel',
  'generic.change': 'Change',
  'generic.close': 'Close',
  'generic.closed': 'Closed',
  'generic.confirm': 'Confirm',
  'generic.delete': 'Delete',
  'generic.delivery': 'Delivery',
  'generic.discarded': 'Discarded',
  'generic.discount': 'Discount',
  'generic.addDiscount': 'Add discount',
  'generic.empty': 'Empty',
  'generic.externalCardTerminal': 'External card terminal',
  'generic.fees': 'Fees',
  'generic.fix': 'Fix',
  'generic.history': 'History',
  'generic.lastOrder': 'Last order',
  'generic.lastUpdated': 'Last updated',
  'generic.menu': 'Menu',
  'generic.note': 'Note',
  'generic.open': 'Open',
  'generic.openBill': 'Open Bill',
  'generic.order': 'Order',
  'generic.orders': 'Orders',
  'generic.refunded': 'Refunded',
  'generic.publish': 'Publish',
  'generic.save': 'Save',
  'generic.saveChanges': 'Save changes',
  'generic.seat': 'Seat',
  'generic.serviceCharge': 'Service Charge',
  'generic.summary Summary': 'Summary',
  'generic.table': 'Table',
  'generic.tips': 'Tips',
  'generic.total': 'Total',
  'generic.totalBill': 'Total bill',
  'generic.printBill': 'Print bill',
  'generic.totalIncTips': 'Total inc. Tips',
  'generic.payment': 'Payment',
  'generic.paid': 'Paid',
  'generic.paidExTips': 'Paid (ex. tips)',
  'generic.received': 'Received',
  'generic.ongoingPayment': 'Ongoing payment',
  'generic.amountReceived': 'Amount received',
  'generic.amountReceivedExTips': 'Amount received (ex. tips)',
  'generic.totalRemaining': 'Total remaining',
  'generic.wastage': 'Wastage',
  'generic.more': 'More',
  'generic.value': 'Value',
  'generic.price': 'Price',
  'generic.other': 'Other',
  'generic.name': 'Name',
  'generic.on': 'On',
  'generic.off': 'Off',
  'generic.minutes': 'Minutes',
  'generic.selectAll': 'Select all',
  'generic.addPaymentMethod': 'Add payment method',
  'header.changeUser': 'Change user',
  'header.pinScreenSettings': 'PIN screen settings',
  'header.Logout': 'Log out',
  'header.logoutInfo': 'Email and password is required to log in again.',
  'header.admin': 'Admin',
  'header.changeLocation': 'Change location',
  'header.integratedTerminalSettings': 'Change available terminals',
  'header.paymentMethods': 'Payment methods',
  'header.payments': 'Payments',
  'header.terminalMode': 'Terminal mode',
  'header.termsAndConditions': 'Terms & conditions',
  'integratedTerminalSettings.dialog.noneAvailable': 'No integrated terminals available',
  'integratedTerminalSettings.dialog.title': 'Available integrated terminals on this device',
  'items.addToCartButton': 'Add to cart',
  'items.addon': 'Extra',
  'items.custom': 'Add',
  'items.removable': 'Remove',
  'items.variant': 'Choose variant',
  'items.giftCard': 'Gift card',
  'items.giftCard.dialog.amount.title': 'Gift card value',
  'items.giftCard.dialog.phone.title': 'Gift card receiver',
  'items.giftCard.dialog.amount.nextAction': 'Next: Phone number',
  'items.giftCard.dialog.amount.validYears': 'This gift card is valid for {years} years.',
  'items.giftCard.dialog.phone.title.input.label': 'Phone Number',
  'items.giftCard.dialog.phone.input.description':
    'They will receive an SMS with a link to see and forward the gift card on email.',
  'items.giftCard.dialog.phone.help.failure':
    'Sorry, that is a phone number we dont know how to verify. Does it have between 8-15 digits?',
  'items.customPrice.dialog.title': 'Add {name} to cart',
  'items.customPrice.dialog.actionLabel.customPrice': 'Add with custom price',
  'items.customPrice.dialog.actionLabel.standardPrice': 'Add with standard price',
  'locations.header': 'Choose location',
  'moveSelectedItems.toast.failure': 'Failed to move selected items to Table ',
  'moveSelectedItems.toast.success': 'Items moved to table ',
  'payment.digitalbill.focusDialog.cancelledContent': 'The payment was cancelled.',
  'payment.focusDialog.cancelledContent': 'The payment was cancelled. What do you want to do with the order?',
  'payment.focusDialog.cancelledTitle': 'Cancelled',
  'payment.focusDialog.discardAction': 'Discard order',
  'payment.focusDialog.cancelPayment': 'Cancel payment',
  'payment.focusDialog.inUseContent': 'Awaiting payment from guest...',
  'payment.focusDialog.inUseTitle': 'In use ⏳',
  'payment.focusDialog.putBackAction': 'Put items back to cart',
  'payment.cashWithoutCashDrawerDialog.header': 'Confirm Cash Payment?',
  'payment.paymentMethods.checkoutUnintegratedPayment.submitAction': 'Complete purchase',
  'payment.paymentMethods.checkoutUnintegratedPayment.title.fallback': 'Additional fields',
  'payment.serviceCharge.contest': 'Remove service charge',
  'payment.serviceCharge.dialog.content': 'Are you sure you want to remove service charge for this bill?',
  'payment.serviceCharge.dialog.secondary': "Don't remove",
  'payment.invoice.dialog.error.totalInkTipsTooLow': 'Total inc. tips can’t be lower than the total for the purchase.',
  'payment.invoice.dialog.error.notANumber': 'Enter a valid number.',
  'paymentButton.status.error': 'Cancelled',
  'paymentButton.status.inUse': 'In use...',
  'paymentButton.status.success': 'Completed',
  'paymentButton.text': 'Pay now',
  'paymentButton.cashConfirmationDialog.title': 'Pay by cash?',
  'paymentButton.cashConfirmationDialog.message': 'Make sure you have received the cash before completing the sale.',
  'paymentButton.cashConfirmationDialog.actionLabel': 'Complete cash sale',
  'paymentButton.cashConfirmationDialog.secondaryActionLabel': 'Cancel',
  'paymentMethodSettings.dialog.header': 'Change selected payment methods',
  'paymentMethodSettings.dialog.integratedTerminals.header': 'Integrated terminals',
  'paymentMethodSettings.dialog.noneAvailable': 'No locally managed payment methods available',
  'paymentMethodSettings.dialog.title': 'Payment methods on this device',
  'paymentMethodSettings.dialog.unintegratedPaymentMethods': 'External payment methods',
  'pinScreenSettings.dialog.title': 'PIN screen settings on this device',
  'pinScreenSettings.dialog.actionLabel': 'Save changes',
  'pinScreenSettings.dialog.showPinScreenOnStartup': 'Show PIN screen when starting the app',
  'pinScreenSettings.dialog.goToPinScreen': 'Go to PIN screen',
  'pinScreenSettings.dialog.manually': 'Manually click ‘Change user’',
  'pinScreenSettings.dialog.afterInactiveMinutes': 'After inactive minutes:',
  'pinScreenSettings.dialog.minutes': 'minutes',
  'pinScreenSettings.dialog.afterEachSale': 'After each sale',
  'pinScreenSetting.manually': 'Manually',
  'pinScreenSetting.afterInactiveMinutes': 'After inactive minutes',
  'pinScreenSetting.afterEachSale': 'After each sale',
  'receipt.print.change': 'Change printer',
  'receipt.qrCode.dialogHeader': 'Scan QR code',
  'receipt.print.dialogHeader': 'Print receipt',
  'receipt.print.printAction': 'Print',
  'receipt.print.error': 'Could not print receipt',
  'receipt.print.success': 'Printing receipt',
  'receipt.print.ios.printNotSupported': 'iOS app does not support receipt printing. Update the app.',
  'receipt.print.ios.noActivePrinter': 'Could not find active printer',
  'receipt.print.ios.errorFetchingPosReceipt': 'Error fetching POS receipt',
  'receipt.print.ios.lostConnection': 'Lost connection with iOS app',
  'receipt.send.error': 'Could not send receipt',
  'receipt.send.success': 'Receipt sent to email',
  'sendPaymentReminder.buttonLabel': 'Send payment reminder',
  'sendPaymentReminder.dialog.header': 'Send payment reminder',
  'sendPaymentReminder.dialog.message':
    'Send a payment reminder to the guest so they get a notification and are able to pay.',
  'sendPaymentReminder.toast.failure': 'Something went wrong while sending payment reminder.',
  'sendPaymentReminder.toast.success': 'Payment reminder successfully sent!',
  'sms.send.success': 'SMS sent',
  'toast.paymentError': 'Cancelled',
  'toast.paymentSuccess': 'Paid',
  'terminalMode.exitDialog.title': 'Exit terminal mode?',
  'terminalMode.exitDialog.text1': 'If you exit terminal mode, the terminal will instead show the ePOS screen.',
  'terminalMode.exitDialog.text2': 'You can switch back to terminal mode in the hamburger menu in ePOS anytime.',
  'terminalMode.exitDialog.action': 'Exit terminal mode',
  'tableMap.editTableMap': 'Edit map',
  'tableMap.changesMade': 'changes made',
  'tableMap.discardChanges': 'Discard changes',
  'tableMap.addMap': 'Add map',
  'tableMap.map': 'Map',
  'tableMap.renameMap': 'Rename map',
  'tableMap.rename': 'Rename',
  'tableMap.settings.rearrangeMaps': 'Rearrange maps',
  'tableMap.settings.tableStatus': 'Table status',
  'tableMap.save.toast.success': 'Table map saved',
  'tableMap.save.toast.error': 'Failed to save table map. Try again.',
  'tableMap.delete.toast.success': 'Table map deleted',
  'tableMap.delete.toast.error': 'Failed to delete table map. Try again.',
  'tableMap.create.toast.success': 'Table map created',
  'tableMap.create.toast.error': 'Failed to create table map. Try again.',
  'tableMap.rename.toast.success': 'Table map renamed',
  'tableMap.publish.toast.error': 'Failed to publish maps. Try again.',
  'tableMap.table.toast.primaryReferenceAlreadyExists':
    'Table {number} already exists. Identical table numbers share the same bill in ePOS.',
  'tableMap.sectionBar.hideMapInEpos': 'Hide map in ePOS',
  'tableMap.sectionBar.showMapInEpos': 'Show map in ePOS',
  'tableMap.sectionBar.deleteMap': 'Delete map',
  'tableMap.preview': 'Preview: ',
  'tableMap.preview.tabletHorizontal': 'Tablet horizontal',
  'tableMap.preview.tabletVertical': 'Tablet vertical',
  'tableMap.preview.phone': 'Phone',
  'tableMap.tableStatusDialog.toggleInfo': 'Mark tables red if no orders have been placed in:',
  'tableMap.tableStatusDialog.settingInfo': 'This helps your staff spot and follow up with inactive tables.',
};
export default translations;
